if(!window.Promise) {
    require('es6-promise').polyfill();
}
import 'common/lib/shim';
import Vue from 'vue';
import router from 'common/router';
import store from 'common/store';
import Filter from 'common/filter';
import VueTap from 'common/directive/vue-tap';
import App from './App';
import 'common/style/common.less';

Vue.config.productionTip = false;

Vue.use(Filter);
Vue.use(VueTap);

new Vue({
    router,
    store,
    render: h => h(App)
}).$mount('#app');



// WEBPACK FOOTER //
// ./src/main.js